import React from 'react';
import { TicketDetailsProvider } from '../context/TicketDetailsProvider';
import HRTicketDetails from './HRTicketDetails';

export default function HRTicketDetailsWrapper() {
  return (
    <TicketDetailsProvider>
      <HRTicketDetails />
    </TicketDetailsProvider>
  );
}
